import React from 'react';

export const DataRow = ({ prefix, title, help, special, buttons, testPrefix = 'data' }) => {
    return (
        <div className="e4-data-row-container" data-testid={`e4-${testPrefix}-row`}>
            <div className="e4-data-row">
                <div className="flex flex-center e4-data-row-title mt5 mb5">
                    {prefix}
                    <div
                        className="title ellipse-holder flex-grow flex flex-center"
                        id="e4-data-row-title"
                        data-testid={`e4-${testPrefix}-row-title`}
                    >
                        <div className="ellipse">{title}</div>
                        {help}
                    </div>
                    <div className="flex flex-center">
                        {special}
                        <div className="ml10 text-center no-wrap table-btns">{buttons}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataRow;
